import api from './api';
import { AnwesenheitKalenderResponse } from '../types';

export const anwesenheitService = {
  kalender: async (von: string, bis: string): Promise<AnwesenheitKalenderResponse> => {
    const response = await api.get('/anwesenheit/kalender', { params: { von, bis } });
    return response.data;
  },
};
